import type { Account } from '@/api';
import { lazyComponent } from '@/app/lazyWithPreload';
import { useMountedOnce } from '@/hooks/useMountedOnce';
import { useSentCopies } from './useSentCopies';

/*
 * The banner's rows (retry, save, "saved to Sent") are fetched only when a
 * copy actually needs the reader (#577 follow-up): almost every session has
 * none. The query that decides runs here, eagerly, and is the same cache
 * entry the banner reads, so it appears exactly when it did. Once shown it
 * stays mounted: its "saved" confirmations live in its own state.
 */
const Banner = lazyComponent(() => import('./SentCopiesBanner'), 'SentCopiesBanner');

export function SentCopiesBanner({ accounts }: { accounts: readonly Account[] }) {
  const open = useSentCopies(accounts);
  const mounted = useMountedOnce(open.length > 0);
  return mounted ? <Banner accounts={accounts} /> : null;
}
